module.exports = __webpack_public_path__ + "static/media/bg-pattern-intro-left-desktop.600d6444.svg";